import wait from 'wait';

import { AppContextType } from '~/context/AppContext';

export const enterElectronKioskMode = async (
  appContext: AppContextType,
): Promise<void> => {
  if (window.electron && !appContext.state.isKioskMode) {
    window.electron.send('message', 'enterKioskMode');

    await appContext.actions.update({
      isKioskMode: true,
    });

    await wait(1000);
  }
};

export const exitElectronKioskMode = async (
  appContext: AppContextType,
): Promise<void> => {
  if (window.electron && appContext.state.isKioskMode) {
    window.electron.send('message', 'exitKioskMode');

    await appContext.actions.update({
      isKioskMode: false,
    });

    await wait(1000);
  }
};
